import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const Brands = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  const brands = [
    {
      name: 'Nexion',
      description: 'Italian styles that inspire',
      logo: 'N',
    },
    {
      name: 'Creanza',
      description: 'Imagination is Everything',
      logo: 'C',
    },
    // {
    //   name: 'Kajaria',
    //   description: 'India\'s largest tile manufacturer',
    //   logo: 'K',
    // },
    // {
    //   name: 'Somany',
    //   description: 'Innovative tile solutions',
    //   logo: 'SO',
    // },
    // {
    //   name: 'RAK Ceramics',
    //   description: 'Global ceramic excellence',
    //   logo: 'R',
    // },
    // {
    //   name: 'Nitco',
    //   description: 'Timeless marble & tile designs',
    //   logo: 'N',
    // },
  ];

  return (
    <section
      id="brands"
      ref={sectionRef}
      data-testid="brands-section"
      className="py-24 md:py-32 bg-sand/50"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs uppercase tracking-[0.2em] text-burgundy font-medium">
            Partners
          </span>
          <h2
            data-testid="brands-heading"
            className="font-playfair text-3xl md:text-4xl lg:text-5xl text-matte-charcoal mt-4"
          >
            Our Featured Brands
          </h2>
        </motion.div>

        {/* Brand Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {brands.map((brand, index) => (
            <motion.div
              key={brand.name}
              data-testid={`brand-card-${index}`}
              className="group bg-stone-white p-8 md:p-10 text-center cursor-pointer transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              {/* Logo Placeholder */}
              <div className="w-16 h-16 mx-auto mb-6 bg-matte-charcoal/5 flex items-center justify-center transition-colors duration-300 group-hover:bg-burgundy/10">
                <span className="font-playfair text-2xl text-matte-charcoal group-hover:text-burgundy transition-colors duration-300">
                  {brand.logo}
                </span>
              </div>
              <h3 className="font-playfair text-xl text-matte-charcoal mb-2 group-hover:text-burgundy transition-colors duration-300">
                {brand.name}
              </h3>
              <p className="text-sm text-stone-grey">
                {brand.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Brands;
